import { createGlobalStyle } from 'styled-components'

export const hasBrandFont = !!process.env.REACT_APP_fontFamily

export const BrandFontStyle = createGlobalStyle`
  @font-face {
    font-family: 'Aeonik';
    src: url('/assets/fonts/aeonik-regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Aeonik';
    src: url('/assets/fonts/aeonik-medium.woff2') format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Aeonik';
    src: url('/assets/fonts/aeonik-bold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  body,
  #main-content,
  button,
  input,
  select,
  textarea {
    font-family: ${ ({ theme }) => theme.fontFamily };
  }
`
